module.exports = __webpack_public_path__ + "img/8.1.f3e5fa04.png";